import('./pbds-header--concept-content.css');
const pbdsHeaderConceptContent = {
    init() {
	}
}

window.initializeComponent.push({ component: "pbds-header--concept-content", init: pbdsHeaderConceptContent.init });

export default() => {
    pbdsHeaderConceptContent.init();
}